var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.featureIsActive("s_type_crawling_pests")
    ? _c(
        "v-menu",
        {
          attrs: { "offset-y": "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function (ref) {
                  var on = ref.on
                  var attrs = ref.attrs
                  return [
                    _c(
                      "round-button",
                      _vm._g(
                        _vm._b(
                          {
                            attrs: {
                              icon: "file_download",
                              "data-testid": "export-csv-button",
                            },
                          },
                          "round-button",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _vm._v(
                          "\n      " + _vm._s(_vm.$t("label")) + "\n      "
                        ),
                        _c("span", { staticClass: "ml-1" }, [_vm._v("▼")]),
                      ]
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            3069379289
          ),
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            [
              _c(
                "v-list-item",
                {
                  attrs: {
                    link: "",
                    "data-testid": "export-csv-format-flying_only",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.exportCsv(_vm.LOCOMOTION_SCOPE.FLYING_ONLY)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("format.flying_only")) + "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-list-item",
                {
                  attrs: {
                    link: "",
                    "data-testid": "export-csv-format-crawling_aware",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.exportCsv(_vm.LOCOMOTION_SCOPE.ALL)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("format.crawling_aware")) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "round-button",
        {
          attrs: { icon: "file_download", "data-testid": "export-csv-button" },
          on: {
            click: function ($event) {
              return _vm.exportCsv(_vm.LOCOMOTION_SCOPE.FLYING_ONLY)
            },
          },
        },
        [_vm._v("\n  " + _vm._s(_vm.$t("label")) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }